import * as React from 'react'
import styled from 'styled-components'
import { rem } from 'polished'
import { mediaQueryUp } from 'components/utils/breakpoint'
import type Pane from 'components/Common/Pane'
import KeyMessageTile from './KeyMessageTile'

const Root = styled.div`
  width: 100%;
  display: grid;
  grid-auto-rows: 1fr;
  grid-auto-flow: row;
  grid-row-gap: ${rem(16)};

  ${mediaQueryUp.tablet} {
    grid-auto-columns: 1fr;
    grid-auto-flow: column;
    grid-auto-rows: auto;
    grid-column-gap: ${rem(16)};
    grid-row-gap: normal;
  }
`

interface Props extends React.ComponentProps<typeof Pane> {
  hash: string
  tiles: Array<{
    fields: {
      title: string
      text: string
      icon: {
        fields: {
          title: string
          file: {
            url: string
          }
        }
      }
    }
  }>
}

function KeyMessageTiles(props: Props) {
  const { hash, tiles } = props

  return (<Root key={hash} id={hash}>
    {tiles.map((tile, index) => <KeyMessageTile
      key={index}
      title={tile.fields.title}
      text={tile.fields.text}
      size="lg xl-y"
      icon={<img src={tile.fields.icon.fields.file.url} alt={tile.fields.icon.fields.title} />}
    />)}
  </Root>)
}

export default KeyMessageTiles
